module.exports = __webpack_public_path__ + "static/media/loading_apng.c80b07f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading_apng.png
// module id = 1644
// module chunks = 0